// based on rc-trigger 5.2.10
import Trigger from './Trigger';
export default Trigger;
